import { useTranslation } from '@/app/_shared/hooks/useTranslation';
import { SvgXMark } from '@/components/common/Icons/XMark';
import { Modal } from '@/components/common/Modal';
import { AskInputSuggestionProvider } from '@/contexts/askInputSuggestion';
import { useMemo } from 'react';
import { AskInputSuggestion } from './AskInputSuggestion';

interface AskNowModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const AskNowModal = ({ isOpen, onClose }: AskNowModalProps) => {
	const { t } = useTranslation();

	const title = useMemo(
		() => (
			<div className="flex flex-col w-full">
				<div className="flex justify-end">
					<button
						onClick={onClose}
						className="text-[var(--color-base-black)] hover:text-gray-700 cursor-pointer hover:bg-gray-100 rounded-full p-1"
						aria-label="Close modal"
						type="button"
					>
						<SvgXMark />
					</button>
				</div>
				<h2 className="text-center text-2xl font-semibold font-manrope mt-[10px]">
					{t('common:askMeAnything')}
				</h2>
			</div>
		),
		[onClose, t],
	);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			size="lg"
			showCloseIcon={false}
			className="rounded-[20px]"
			closeOnOverlayClick={false}
		>
			<AskInputSuggestionProvider>
				<div className="pb-[10px]">
					<AskInputSuggestion />
				</div>
			</AskInputSuggestionProvider>
		</Modal>
	);
};
